import type { ApiResponse, BrandDashboardAttributionCodeOption } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

interface BrandDashboardAttributionCodesParams {
  search?: string;
  limit?: number;
}

export const fetchBrandDashboardAttributionCodes = async (
  params: BrandDashboardAttributionCodesParams = {}
): Promise<BrandDashboardAttributionCodeOption[]> => {
  const { data } = await api.get<ApiResponse<{ data: BrandDashboardAttributionCodeOption[] }>>(
    '/dashboard/brands/stats/attribution-codes',
    { params }
  );

  return data.data?.data ?? [];
};

export const useBrandDashboardAttributionCodes = (
  params: BrandDashboardAttributionCodesParams = {}
) => {
  return useQuery<BrandDashboardAttributionCodeOption[], Error>({
    queryKey: ['brand-dashboard-attribution-codes', params],
    queryFn: () => fetchBrandDashboardAttributionCodes(params),
    staleTime: 5 * 60 * 1000,
  });
};
